/**
 * Gets site feature value from session storage.
 * @param siteFeature One of site feature enumeration values.
 * @returns An object of `ISiteFeature` if site feature is present in session storage.
 * `undefined` value in case site feature is absent in storage.
 */
export var getSiteFeatureFromSessionStorage = function (siteFeature) {
    var sessionStorageValue = sessionStorage.getItem(siteFeature);
    return sessionStorageValue !== null
        ? { name: siteFeature, value: (sessionStorageValue === 'true') }
        : undefined;
};
